// extracted by mini-css-extract-plugin
export var progressBar = "_k6-0";
export var progressBarInner = "_k6-1";